var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookRoyal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_496)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#15264C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4798 30V20.6154H15V17.2365H17.4798V14.3505C17.4798 12.0826 18.9447 10 22.32 10C23.6866 10 24.6972 10.1311 24.6972 10.1311L24.6175 13.2864C24.6175 13.2864 23.5869 13.2764 22.4623 13.2764C21.2451 13.2764 21.0501 13.8377 21.0501 14.7693V17.2365H24.7143L24.5549 20.6154H21.0501V30H17.4798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookRoyal);
export default __webpack_public_path__ + "static/media/facebook-royal.7b180580a6ee8f63e68ce6bac4609227.svg";
export { ForwardRef as ReactComponent };